import ApiEventHandler from './schema/ApiEventHandler';
import ApiEventRegisterArgs from './schema/ApiEventRegisterArgs';
import ApiEventResponseArgs from './schema/ApiEventResponseArgs';
import { ApiEventCallback } from './schema/ApiEventCallback';
import { DialogMessageParentArgs } from './events/getDisplayDialogEvent';
import { OutlookEventDispId } from './schema/OutlookEventDispId';

export { default as registerApiEvent } from './registerApiEvent';
export { default as unregisterApiEvent } from './unregisterApiEvent';
export { default as triggerApiEvent } from './triggerApiEvent';
export { default as triggerAllApiEvents } from './triggerAllApiEvents';
export { deleteAllApiEventHandlers } from './storage/ActiveApiEvents';

export {
    triggerAppointmentTimeChangedEvent,
} from './eventTriggers/triggerAppointmentTimeChangedEvent';
export { triggerAttachmentsChangedEvent } from './eventTriggers/triggerAttachmentsChangedEvent';
export { triggerRecipientsChangedEvent } from './eventTriggers/triggerRecipientsChangedEvent';
export { triggerRecurrenceChangedEvent } from './eventTriggers/triggerRecurrenceChangedEvent';
export { triggerLocationsChangedEvent } from './eventTriggers/triggerLocationsChangedEvent';

export {
    ApiEventCallback,
    ApiEventHandler,
    ApiEventRegisterArgs,
    ApiEventResponseArgs,
    DialogMessageParentArgs,
    OutlookEventDispId,
};
